import { config } from '../config';
import { headers, fetchAPI, SpanTag, stleaf, APIResponse } from '../helpers';

export interface Prediction {
  description: string;
  matched_substrings: Array<{ length: number; offset: number }>;
  place_id: string;
  reference: string;
  structured_formatting: {
    main_text: string;
    secondary_text: string;
  };
  terms: Array<{ offset: number; value: string }>;
  types: string[];
}

export interface SearchLocationsResponse {
  status: string;
  predictions: Prediction[];
}

export interface SearchLocationsOptions {
  headers?: Record<string, string>;
  query?: Record<string, string>;
}

export const searchLocations = (
  st: SpanTag,
  search: string,
  { headers: customHeaders, query }: SearchLocationsOptions = {
    headers: {},
    query: {},
  },
): Promise<APIResponse<SearchLocationsResponse>> => {
  const url = new URL(`${config.API_URL}/v1/location`);
  const searchParams = new URLSearchParams({ ...query, input: search });
  url.search = searchParams.toString();

  return fetchAPI(stleaf(st, 'eiwa8p'), url, {
    method: 'GET',
    credentials: 'include',
    headers: { ...headers, ...customHeaders },
  });
};

export interface GetLocationResponse {
  address_components: Array<{
    long_name: string;
    short_name: string;
    types: string[];
  }>;
  formatted_address: string;
  geometry: {
    location: { lat: number; lng: number };
    viewport: {
      northeast: { lat: number; lng: number };
      southwest: { lat: number; lng: number };
    };
  };
  name: string;
  place_id: string;
  reference: string;
  types: string[];
  url: string;
  utc_offset: number;
  vicinity: string;
}

export interface GetLocationOptions {
  headers?: Record<string, string>;
}

export const getLocation = (
  st: SpanTag,
  id: string,
  { headers: customHeaders }: GetLocationOptions = { headers: {} },
): Promise<APIResponse<GetLocationResponse>> => {
  const url = new URL(`${config.API_URL}/v1/location/${id}`);
  return fetchAPI(stleaf(st, 'ohp7di'), url, {
    method: 'GET',
    credentials: 'include',
    headers: { ...headers, ...customHeaders },
  });
};
